import React from "react";
import Chart from "react-apexcharts";

const SiteVsFormHeatmap = ({ data = [] }) => {
  const series =
    data?.length > 0
      ? data
      : [
          {
            name: "Site 01",
            data: [
              { x: "DEMOG...", y: 5 },
              { x: "MEDIC...", y: 7 },
              { x: "ADVER...", y: 23 },
              { x: "CONCO...", y: 19 },
              { x: "VITAL...", y: 13 },
              { x: "LABOR...", y: 25 },
              { x: "ECG", y: 12 },
              { x: "DRUG A...", y: 11 },
              { x: "PK SAM...", y: 8 },
              { x: "ELIGIBI...", y: 7 },
              { x: "PHYSIC...", y: 6 },
              { x: "STUDY ...", y: 4 },
            ],
          },
          {
            name: "Site 02",
            data: [
              { x: "DEMOG...", y: 12 },
              { x: "MEDIC...", y: 20 },
              { x: "ADVER...", y: 54 },
              { x: "CONCO...", y: 40 },
              { x: "VITAL...", y: 27 },
              { x: "LABOR...", y: 53 },
              { x: "ECG", y: 11 },
              { x: "DRUG A...", y: 28 },
              { x: "PK SAM...", y: 25 },
              { x: "ELIGIBI...", y: 9 },
              { x: "PHYSIC...", y: 17 },
              { x: "STUDY ...", y: 10 },
            ],
          },
          {
            name: "Site 03",
            data: [
              { x: "DEMOG...", y: 5 },
              { x: "MEDIC...", y: 7 },
              { x: "ADVER...", y: 23 },
              { x: "CONCO...", y: 19 },
              { x: "VITAL...", y: 13 },
              { x: "LABOR...", y: 25 },
              { x: "ECG", y: 12 },
              { x: "DRUG A...", y: 11 },
              { x: "PK SAM...", y: 8 },
              { x: "ELIGIBI...", y: 7 },
              { x: "PHYSIC...", y: 6 },
              { x: "STUDY ...", y: 4 },
            ],
          },
          {
            name: "Site 04",
            data: [
              { x: "DEMOG...", y: 12 },
              { x: "MEDIC...", y: 20 },
              { x: "ADVER...", y: 54 },
              { x: "CONCO...", y: 40 },
              { x: "VITAL...", y: 27 },
              { x: "LABOR...", y: 53 },
              { x: "ECG", y: 11 },
              { x: "DRUG A...", y: 28 },
              { x: "PK SAM...", y: 25 },
              { x: "ELIGIBI...", y: 9 },
              { x: "PHYSIC...", y: 17 },
              { x: "STUDY ...", y: 10 },
            ],
          },
          {
            name: "Site 05",
            data: [
              { x: "DEMOG...", y: 12 },
              { x: "MEDIC...", y: 20 },
              { x: "ADVER...", y: 54 },
              { x: "CONCO...", y: 40 },
              { x: "VITAL...", y: 27 },
              { x: "LABOR...", y: 53 },
              { x: "ECG", y: 11 },
              { x: "DRUG A...", y: 28 },
              { x: "PK SAM...", y: 25 },
              { x: "ELIGIBI...", y: 9 },
              { x: "PHYSIC...", y: 17 },
              { x: "STUDY ...", y: 10 },
            ],
          },
        ];

  const options = {
    chart: {
      type: "heatmap",
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
        colors: ["#1e293b"],
      },
    },
    stroke: {
      width: 2,
      colors: ["#ffffff"],
    },
    plotOptions: {
      heatmap: {
        radius: 4,
        colorScale: {
          ranges: [
            {
              from: 0,
              to: 0,
              color: "#eef2f7",
            },
            {
              from: 1,
              to: 10,
              color: "#f8dede",
            },
            {
              from: 11,
              to: 20,
              color: "#f4b7b7",
            },
            {
              from: 21,
              to: 40,
              color: "#f58c8c",
            },
            {
              from: 41,
              to: 100,
              color: "#ff3b30",
            },
          ],
        },
      },
    },
    xaxis: {
      labels: {
        rotate: 0,
        trim: true,
        style: {
          fontSize: "12px",
          fontWeight: 600,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "13px",
          fontWeight: 600,
        },
      },
    },
    tooltip: {
      y: {
        formatter: (value) => `${value || 0} queries`,
      },
    },
  };

  return (
    <div className="p-3">
      <Chart options={options} series={series} type="heatmap" height={230} />
    </div>
  );
};

export default SiteVsFormHeatmap;
